import { forwardRef, type HTMLAttributes } from 'react'
import AddIcon from './icons/add'
import AddDisabledIcon from './icons/addDisabled'
import InfoIcon from './icons/info'
import InfoWhiteIcon from './icons/infoWhite'
import CheckedIcon from './icons/checked'
import HourGlassIcon from './icons/hour-glass'
import LoadingAnimatedIcon from './icons/loading-animated'
import leftArrowIcon from './icons/leftArrow'
import rightArrowIcon from './icons/rightArrow'
import verifyIcon from './icons/verify'
import verifyWhiteIcon from './icons/verifyWhite'
import clipIcon from './icons/clip'
import closeIcon from './icons/close'
import receiptEditIcon from './icons/receiptEdit'
import receiptDiscountIcon from './icons/receiptDiscount'
import closeWhiteIcon from './icons/closeWhite'
import toggleOffIcon from './icons/toggleOff'
import importBlackIcon from './icons/importBlack'
import closeCircleIcon from './icons/closeCircle'
import trashModalIcon from './icons/trashModal'
import percillconIcon from './icons/percillcon'
import singleUserHexagonIcon from './icons/singleUserHexagon'
import multipleUserHexagonIcon from './icons/multipleUserHexagon'
import boxIcon from './icons/boxIcon'
import certifiedIcon from './icons/certified'
import brandIcon from './icons/brand'
import noResultsIcon from './icons/noResults'
import desconsiderarBigIcon from './icons/desconsiderarBig'
import considerarIcon from './icons/considerar'
import sharedIcon from './icons/shared'
import mailIcon from './icons/mail'
import trashTableIcon from './icons/trashTable'
import linkIcon from './icons/atribuir'
import atribuirIcon from './icons/atribuir'
import detailYellowIcon from './icons/detailYellow'
import filterIcon from './icons/filter'
import searchIcon from './icons/search'
import moveTabIcon from './icons/moveTab'
import crownIcon from './icons/crown'
import isReviewedIcon from './icons/isReviewed'
import uncheckedModalIcon from './icons/uncheckedModal'
import toastErrorIcon from './icons/toastError'
import noUpdateIcon from './icons/noUpdate'
import toastSuccessIcons from './icons/toastSuccess'
import infoCircleFillIcon from './icons/infoCircleFill'
import receiptDiscountDisabledIcon from './icons/receiptDiscountDisabled'
import documentTextIcon from './icons/documentText'
import documentTextDisabledIcon from './icons/documentTextDisabled'
import breadcrumbSuccessIcon from './icons/breadcrumbSuccess'
import arrowHRIcon from './icons/arrowHR'
import arrowHLIcon from './icons/arrowHL'
import modalWarningIcon from './icons/modalWarning'
import successModalIcon from './icons/sucessModal'
import importExcelIcon from './icons/importExcel'
import eyeIcon from './icons/eye'
import downloadIcon from './icons/download'
import alreadyRegisteredIcon from './icons/alreadyRegistered'
import availableForUpdateIcon from './icons/avaliableForUpdate'
import availableForRegistrationIcon from './icons/avaliableForRegistrarion'
import certificationTableIcon from './icons/certificationTable'
import chainOfCustodyIcon from './icons/chainOfCustody'
import historyCreateIcon from './icons/historyCreate'
import historyExportIcon from './icons/historyExport'
import historyGenerateIcon from './icons/historyGenerate'
import trashIcon from './icons/trash'
import documentTextErrorIcon from './icons/documentTextError'
import arrowDownIcon from './icons/arrowDown'
import checkInputIcon from './icons/checkInput'
import profileAddIcon from './icons/profileAdd'
import importIcon from './icons/import'
import graphIcon from './icons/graph'
import noteBlackIcon from './icons/noteBlack'
import noteIcon from './icons/note'
import truckIcon from './icons/truck'
import changeStatusIcon from './icons/changeStatus'
import detailIcon from './icons/detail'
import saleIcon from './icons/sale'
import buyIcon from './icons/buy'
import buyAndSaleIcon from './icons/buyAndSale'
import logoCeoxIcon from './icons/logoCeox'
import logoutBlackIcon from './icons/logoutBlack'
import logoutIcon from './icons/logout'
import dropIcon from './icons/drop'
import hasNotificationIcon from './icons/hasNotification'
import collectDataIcon from './icons/collectData'
import peopleIcon from './icons/people'
import googleIcon from './icons/google'
import eyeHidePasswordIcon from './icons/eyeHidePassword'
import eyePasswordIcon from './icons/eyePassword'
import exportIcon from './icons/export'
import xRomaneioIcon from './icons/xRomaneio'
import xDivergeIcon from './icons/xDiverge'
import timeNotaFiscalIcon from './icons/timeNotaFiscal'
import taskIcon from './icons/task'
import producterIcon from './icons/producter'
import intermediaryIcon from './icons/intemediary'
import updatePendingIcon from './icons/updatePending'
import xNotaFiscalIcon from './icons/xNotaFiscal'
import nNotaFiscalIcon from './icons/nNotaFiscal'
import inscEstadualIcon from './icons/inscEstadual'
import tickSquareIcon from './icons/tickSquare'
import hiperlinkIcon from './icons/hiperlink'
import boxImportNfIcon from './icons/boxImportNf'
import microsoftIcon from './icons/microsoft'
import compareIcon from './icons/compare'
import toAssignIcon from './icons/toAssign'
import certifiedExpiredIcon from './icons/certifiedExpired'
import accessoryIcon from './icons/accessory'
import historyIcon from './icons/history'
import moreVerticalIcon from './icons/moreVertical'
import reativarIcon from './icons/reativar'
import inativarIcon from './icons/inativar'
import alertTriangleIcon from './icons/alertTriangle'
import warningTriangleOutlineIcon from './icons/warningTriangleOutline'
import mapaIcon from './icons/mapa'
import calendarIcon from './icons/calendar'
import arrowUpIcon from './icons/arrowUp'
import codeIcon from './icons/code'
import copyIcon from './icons/copy'
import circleIcon from './icons/circle'
import EditIcon from './icons/edit'
import SaveIcon from './icons/save'
import simulationIcon from './icons/simulation'
import externalLinkIcon from './icons/external'
import companyIcon from './icons/company'

export const iconRegistry = {
  add: AddIcon,
  addDisabled: AddDisabledIcon,
  edit: EditIcon,
  info: InfoIcon,
  infoWhite: InfoWhiteIcon,
  checked: CheckedIcon,
  hourGlass: HourGlassIcon,
  loadingAnimated: LoadingAnimatedIcon,
  leftArrow: leftArrowIcon,
  rightArrow: rightArrowIcon,
  verify: verifyIcon,
  verifyWhite: verifyWhiteIcon,
  clip: clipIcon,
  close: closeIcon,
  closeWhite: closeWhiteIcon,
  receiptEdit: receiptEditIcon,
  receiptDiscount: receiptDiscountIcon,
  receiptDiscountDisabled: receiptDiscountDisabledIcon,
  toggleOff: toggleOffIcon,
  importBlack: importBlackIcon,
  closeCircle: closeCircleIcon,
  trash: trashIcon,
  trashModal: trashModalIcon,
  percillcon: percillconIcon,
  singleUserHexagon: singleUserHexagonIcon,
  multipleUserHexagon: multipleUserHexagonIcon,
  box: boxIcon,
  certified: certifiedIcon,
  brand: brandIcon,
  noResults: noResultsIcon,
  desconsiderarBig: desconsiderarBigIcon,
  considerar: considerarIcon,
  shared: sharedIcon,
  mail: mailIcon,
  trashTable: trashTableIcon,
  link: linkIcon,
  atribuir: atribuirIcon,
  detailYellow: detailYellowIcon,
  filter: filterIcon,
  search: searchIcon,
  moveTab: moveTabIcon,
  crown: crownIcon,
  isReviewed: isReviewedIcon,
  checkedModal: CheckedIcon,
  uncheckedModal: uncheckedModalIcon,
  toastError: toastErrorIcon,
  toastSuccess: toastSuccessIcons,
  noUpdate: noUpdateIcon,
  infoCircleFill: infoCircleFillIcon,
  documentText: documentTextIcon,
  documentTextDisabled: documentTextDisabledIcon,
  documentTextError: documentTextErrorIcon,
  breadcrumbSuccess: breadcrumbSuccessIcon,
  arrowHR: arrowHRIcon,
  arrowHL: arrowHLIcon,
  modalWarning: modalWarningIcon,
  successModal: successModalIcon,
  importExcel: importExcelIcon,
  eye: eyeIcon,
  download: downloadIcon,
  alreadyRegistered: alreadyRegisteredIcon,
  availableForUpdate: availableForUpdateIcon,
  availableForRegistration: availableForRegistrationIcon,
  certificationTable: certificationTableIcon,
  chainOfCustody: chainOfCustodyIcon,
  historyCreate: historyCreateIcon,
  historyExport: historyExportIcon,
  historyGenerate: historyGenerateIcon,
  arrowDown: arrowDownIcon,
  checkInput: checkInputIcon,
  profileAdd: profileAddIcon,
  import: importIcon,
  graph: graphIcon,
  noteBlack: noteBlackIcon,
  note: noteIcon,
  truck: truckIcon,
  changeStatus: changeStatusIcon,
  detail: detailIcon,
  sale: saleIcon,
  buy: buyIcon,
  buyAndSale: buyAndSaleIcon,
  logoCeox: logoCeoxIcon,
  logoutBlack: logoutBlackIcon,
  logout: logoutIcon,
  drop: dropIcon,
  hasNotification: hasNotificationIcon,
  collectData: collectDataIcon,
  people: peopleIcon,
  google: googleIcon,
  eyeHidePassword: eyeHidePasswordIcon,
  eyePassword: eyePasswordIcon,
  export: exportIcon,
  xRomaneio: xRomaneioIcon,
  xDiverge: xDivergeIcon,
  timeNotaFiscal: timeNotaFiscalIcon,
  task: taskIcon,
  producter: producterIcon,
  intemediary: intermediaryIcon,
  updatePending: updatePendingIcon,
  xNotaFiscal: xNotaFiscalIcon,
  nNotaFiscal: nNotaFiscalIcon,
  inscEstadual: inscEstadualIcon,
  tickSquare: tickSquareIcon,
  hiperlink: hiperlinkIcon,
  boxImportNf: boxImportNfIcon,
  microsoft: microsoftIcon,
  compare: compareIcon,
  toAssign: toAssignIcon,
  certifiedExpired: certifiedExpiredIcon,
  accessory: accessoryIcon,
  history: historyIcon,
  moreVertical: moreVerticalIcon,
  reativar: reativarIcon,
  inativar: inativarIcon,
  alertTriangle: alertTriangleIcon,
  warningTriangleOutline: warningTriangleOutlineIcon,
  mapa: mapaIcon,
  calendar: calendarIcon,
  arrowUp: arrowUpIcon,
  code: codeIcon,
  copy: copyIcon,
  circle: circleIcon,
  save: SaveIcon,
  simulation: simulationIcon,
  externalLink: externalLinkIcon,
  company: companyIcon,
}

export interface IIconBase {
  color?: string
  width?: number
  height?: number
  type?: string
  className?: string
  onClick?: () => void
}

type IconType = typeof iconRegistry

export type TIconNames = keyof IconType

interface IIconProps
  extends
    IIconBase,
    Omit<HTMLAttributes<HTMLSpanElement>, 'color' | 'onClick' | 'className'> {
  name: TIconNames
}

export const CustomSvgIcon = forwardRef<HTMLSpanElement, IIconProps>(
  ({ name, color, height, width, type, className, onClick, ...rest }, ref) => {
    const SVGIcon = iconRegistry[name]
    const resolvedColor = !color && className ? 'currentColor' : color

    return (
      <span ref={ref} className={className} onClick={onClick} {...rest}>
        <SVGIcon
          color={resolvedColor}
          height={height}
          width={width}
          type={type}
        />
      </span>
    )
  },
)

CustomSvgIcon.displayName = 'CustomSvgIcon'
